export default __webpack_public_path__ + "static/media/bw_photos_hamptons-2.dd57c43a.jpg";